export const formatToStartCase = (text = "") => {
  return text
    .replace(/_/g, " ") // replace underscores with space
    .toLowerCase() // normalize to lowercase
    .replace(
      /\b\w/g,
      (
        char, // capitalize first letter of each word
      ) => char.toUpperCase(),
    );
};
